"use client";

import LegalPage from "@/components/legal/LegalPage";

export default function PrivacyPolicy() {
  return (
    <LegalPage
      pageTitle="Privacy Policy"
      subtitle="Your privacy is important to us"
      legalKey="privacy_policy"
    />
  );
}
